import api from '../../api';
import errors from '../lib/errors';

export default ({ uids: profileids, q }, params, onRequest, onSuccess, onFail, foreground = true) => {
  const { getState, file_extension } = params;

  const { metadata = {}, profiles = {} } = getState();

  if (!profileids || profileids.length === 0) {
    const message = 'Sorry, no more profiles to fetch';
    onFail({ profileids, error: { message } }, params, foreground);
    return;
  }

  const viewedData = {
    ...metadata,
    markViewed: foreground,
  };

  const { self = {} } = profiles;
  const { gender } = self;

  onRequest({ profileids }, params, foreground);

  api
    // eslint-disable-next-line prettier/prettier
    .get(
      '/profiles/list',
      { params: { profileids, q, viewedData, file_extension } },
      { loggedInUserGender: gender },
    )
    .then(response => onSuccess({ ...response.data, profileids }, params, foreground))
    .catch(error => onFail({ profileids, ...errors.clean(error) }, params, foreground));
};
